const getScaleSectionWidth = ({ scaleWidth, max, min, step, }) => scaleWidth / (max - min + step);
export default getScaleSectionWidth;
